import React from 'react';

import classNames from 'classnames';

import * as styles from './toggle.module.css';

export function Toggle ({
  onClick,
  selectedPriceIdx,
  priceOption1,
  priceOption2
}) {
  return (
    <div className={styles.toggleContainer}>
      <p
        className={
          classNames(
            'body',
            styles.toggleLabel,
            selectedPriceIdx && styles.toggleLabelNonactive
          )
        }
      >
        <strong>{priceOption1?.label}</strong>
      </p>
      <label className={styles.toggleSwitch}>
        <input
          name='Price Toggle'
          type='checkbox'
          checked={selectedPriceIdx}
          onChange={onClick}
        />
        <span className={styles.slider}></span>
      </label>
      <p
        className={
          classNames(
            'body',
            styles.toggleLabel,
            !selectedPriceIdx && styles.toggleLabelNonactive
          )
        }
      >
        <strong>{priceOption2?.label}</strong>
      </p>
    </div>
  );
};
